import { ImageStoryblok } from '../../customTypes/storyblok-types';
import { StoryblokImage } from './StoryblokImage';

export const StoryblokFloatingImage = ({ filename, alt, focus }: ImageStoryblok) => {
  if (!filename) return <></>;
  return (
    <StoryblokImage src={filename} alt={alt} focus={focus} layout="fill" sizes="256px, 512px" />
  );
};
